module.exports = {
	"Basic 1": [
		{
			"statement": "Introduce yourself and say four personal characteristics.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say four physical characteristics.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say your age and profession.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say your nationality and marital status.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say three objects you have.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say where you live and work.",
			"image": ""
		},
		{
			"statement": "Ask three questions with the question word who.",
			"image": ""
		},
		{
			"statement": "Ask three questions with the question word what.",
			"image": ""
		},
		{
			"statement": "Say the position of three objects in the classroom.",
			"image": ""
		},
		{
			"statement": "Say three things you like.",
			"image": ""
		},
		{
			"statement": "Say three things you don’t like.",
			"image": ""
		},
		{
			"statement": "Write the numbers 8, 11, and 12.",
			"image": ""
		},
		{
			"statement": "Write the numbers 3, 7, and 9.",
			"image": ""
		},
		{
			"statement": "Say three greetings.",
			"image": ""
		},
		{
			"statement": "Say three farewells.",
			"image": ""
		},
		{
			"statement": "Say the opposite of tall, thin, and horrible.",
			"image": ""
		},
		{
			"statement": "Say the opposite of ugly, old, and short.",
			"image": ""
		},
		{
			"statement": "Say the opposite of organized, happy, and shy.",
			"image": ""
		},
		{
			"statement": "Answer the question \"Where do you live?\" with the preposition in.",
			"image": ""
		},
		{
			"statement": "Answer the question \"Where do you live?\" with the preposition on.",
			"image": ""
		},
		{
			"statement": "Answer the question \"When is your birthday?\"",
			"image": ""
		},
		{
			"statement": "Answer the question \"When are your English classes?\"",
			"image": ""
		},
		{
			"statement": "Say the position of three objects in this picture.",
			"image": "shutterstock_228914260"
		},
		{
			"statement": "Introduce this woman and say her age and profession.",
			"image": "shutterstock_421202407"
		},
		{
			"statement": "Introduce this man and say his nationality and marital status.",
			"image": "shutterstock_262734242"
		},
		{
			"statement": "Describe this woman in three sentences.",
			"image": "shutterstock_562454995"
		},
		{
			"statement": "Describe this man in three sentences.",
			"image": "shutterstock_370353149"
		},
		{
			"statement": "Say the position of three objects in this picture.",
			"image": "shutterstock_306448652"
		},
		{
			"statement": "Say two things you have and where you live.",
			"image": ""
		},
		{
			"statement": "Say your profession and where you work.",
			"image": ""
		},
		{
			"statement": "Say three parts of a day.",
			"image": ""
		},
		{
			"statement": "Say two seasons.",
			"image": ""
		},
		{
			"statement": "Say three months.",
			"image": ""
		},
		{
			"statement": "Say three days of the week.",
			"image": ""
		},
		{
			"statement": "Say the correct conjugation of the verb To Be.",
			"image": ""
		},
		{
			"statement": "Change the following sentence into the negative and interrogative forms: \"Paul is home.\"",
			"image": ""
		}
	],
	"Basic 2": [
		{
			"statement": "Introduce yourself and say three things you like to do.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say three things you don’t like to do.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say three household chores you do.",
			"image": ""
		},
		{
			"statement": "Introduce yourself and say three tasks you do at work.",
			"image": ""
		},
		{
			"statement": "Say three activities your best friend likes to do.",
			"image": ""
		},
		{
			"statement": "Say three activities your best friend doesn’t like to do.",
			"image": ""
		},
		{
			"statement": "Say what your best friend is doing at this moment.",
			"image": ""
		},
		{
			"statement": "Say three activities you never do.",
			"image": ""
		},
		{
			"statement": "Say three activities you always do.",
			"image": ""
		},
		{
			"statement": "Say three activities you do on vacation.",
			"image": ""
		},
		{
			"statement": "Say three activities you do in the morning.",
			"image": ""
		},
		{
			"statement": "Say three activities you are not doing now.",
			"image": ""
		},
		{
			"statement": "Give two different answers for the question \"What is he doing?\" based on the following picture:",
			"image": "shutterstock_219585166"
		},
		{
			"statement": "Change the following sentence into the interrogative and negative forms: \"I play soccer.\"",
			"image": ""
		},
		{
			"statement": "Change the following sentence into the interrogative and negative forms: \"He likes popcorn.\"",
			"image": ""
		},
		{
			"statement": "Change the following sentence into the interrogative and negative forms: \"They are driving to Los Angeles.\"",
			"image": ""
		},
		{
			"statement": "Answer the questions: \"What time do you wake up?\" and \"What time do you go to sleep?\"",
			"image": ""
		},
		{
			"statement": "Answer the questions: \"What time does your father or mother wake up?\" and \"What time does your father or mother go to sleep?\"",
			"image": ""
		},
		{
			"statement": "Say where and what time you have lunch.",
			"image": ""
		},
		{
			"statement": "Create two questions with how often—one with the subject pronoun you and one with the subject pronoun he.",
			"image": ""
		},
		{
			"statement": "Create two questions with where— one with the subject pronoun you and one with the subject pronoun he.",
			"image": ""
		},
		{
			"statement": "Create two questions with what time— one with the subject pronoun you and one with the subject pronoun he.",
			"image": ""
		},
		{
			"statement": "Create two questions with when— one with the subject pronoun you and one with the subject pronoun he.",
			"image": ""
		},
		{
			"statement": "Give two different answers for the question \"What are they doing?\" based on the following picture:",
			"image": "shutterstock_603461438"
		},
		{
			"statement": "Describe the following picture in three sentences with There + To Be.",
			"image": "shutterstock_456997735"
		},
		{
			"statement": "Describe the following picture in three sentences with There + To Be.",
			"image": "shutterstock_574690981"
		},
		{
			"statement": "Describe the following picture with three adjectives.",
			"image": "shutterstock_302996438"
		},
		{
			"statement": "Describe the following living room with three prepositions of place.",
			"image": "shutterstock_289196939"
		},
		{
			"statement": "Describe the following bedroom in three sentences with There + To Be.",
			"image": "shutterstock_362198879"
		},
		{
			"statement": "What are the opposites of messy, dirty, and tacky?",
			"image": ""
		},
		{
			"statement": "What are the opposites of safe, amazing, and noisy?",
			"image": ""
		},
		{
			"statement": "Mention three places in a house.",
			"image": ""
		},
		{
			"statement": "Mention three pieces of furniture in a living room and/or bathroom.",
			"image": ""
		},
		{
			"statement": "Mention three pieces of furniture in a kitchen and/or bedroom.",
			"image": ""
		},
		{
			"statement": "Write the numbers 20, 30, and 40.",
			"image": ""
		},
		{
			"statement": "Write the numbers 57, 61, and 93.",
			"image": ""
		}
	],
	"Basic 3": [
		{
			"statement": "Change the following sentence into the plural form: \"The child is beside the wolf.\"",
			"image": ""
		},
		{
			"statement": "Change the following sentence into the plural form: \"The man is wearing a beautiful watch.\"",
			"image": ""
		},
		{
			"statement": "Mention some activities you did yesterday.",
			"image": ""
		},
		{
			"statement": "Mention three activities you did on your last trip.",
			"image": ""
		},
		{
			"statement": "Mention three activities you didn’t do last week.",
			"image": ""
		},
		{
			"statement": "Ask a question in the past with where and one with what.",
			"image": ""
		},
		{
			"statement": "Ask a question with how many and one with how much.",
			"image": ""
		},
		{
			"statement": "Answer the question \"How much do you spend a day?\"",
			"image": ""
		},
		{
			"statement": "Answer the question \"How many hours do you work a day?\"",
			"image": ""
		},
		{
			"statement": "Create a sentence with a lot of and one with a few.",
			"image": ""
		},
		{
			"statement": "Create a sentence with many and one with little.",
			"image": ""
		},
		{
			"statement": "Say what you had for breakfast and lunch yesterday.",
			"image": ""
		},
		{
			"statement": "Name five different fruits.",
			"image": ""
		},
		{
			"statement": "Say four objects that are used to have lunch or dinner.",
			"image": ""
		},
		{
			"statement": "Create a question with how far.",
			"image": ""
		},
		{
			"statement": "Create a question with how long.",
			"image": ""
		},
		{
			"statement": "Mention three activities you used to do when you were a child.",
			"image": ""
		},
		{
			"statement": "Mention three activities you didn’t use to do when you were a teenager.",
			"image": ""
		},
		{
			"statement": "Narrate what you did yesterday morning.",
			"image": ""
		},
		{
			"statement": "Narrate your day at work yesterday.",
			"image": ""
		},
		{
			"statement": "Say what happened to the man according to the picture.",
			"image": "shutterstock_378746530"
		},
		{
			"statement": "Say what happened to the woman according to the picture.",
			"image": "shutterstock_310310333"
		},
		{
			"statement": "Say two words or expressions used to react to prices.",
			"image": ""
		},
		{
			"statement": "What are the coins used in the U.S.?",
			"image": ""
		},
		{
			"statement": "What is the past form of the verbs to get, to buy, to sell, to have, and to spend?",
			"image": ""
		},
		{
			"statement": "What is the past form of the verbs to take, to see, to think, to keep, and to sleep?",
			"image": ""
		},
		{
			"statement": "Answer the question \"How many hours did you sleep last night?\"",
			"image": ""
		},
		{
			"statement": "Answer the question \"How much did you spend yesterday?\"",
			"image": ""
		},
		{
			"statement": "Say four uncountable nouns.",
			"image": ""
		},
		{
			"statement": "Mime the actions: take pictures, chat online, and sunbathe.",
			"image": ""
		},
		{
			"statement": "Talk about your educational background.",
			"image": ""
		},
		{
			"statement": "Talk about your professional background.",
			"image": ""
		},
		{
			"statement": "Say five verbs that have regular past forms.",
			"image": ""
		},
		{
			"statement": "Complete the narration: \"Last week, I…Then…\"",
			"image": ""
		},
		{
			"statement": "Complete the narration: \"Two days ago, I…After that…\"",
			"image": ""
		},
		{
			"statement": "Say a noun that only has the plural form.",
			"image": ""
		}
	],
	"Intermediate 1": [
		{
			"statement": "Give your opinion on Wise Up by using three adjectives.",
			"image": ""
		},
		{
			"statement": "Give your opinion on your city by using three adjectives.",
			"image": ""
		},
		{
			"statement": "Give your opinion on your job by using three adjectives.",
			"image": ""
		},
		{
			"statement": "Complete the sentence \"I think that…\"",
			"image": ""
		},
		{
			"statement": "What do you say if you don’t understand a message?",
			"image": ""
		},
		{
			"statement": "What sentences can you use to express agreement and disagreement?",
			"image": ""
		},
		{
			"statement": "Do you agree with the following sentence? Justify. \"People are destroying our planet.\"",
			"image": ""
		},
		{
			"statement": "Do you agree with the following sentence? Justify. \"It is important to control children’s use of the internet.\"",
			"image": ""
		},
		{
			"statement": "Do you agree with the following sentence? Justify. \"Social media change our relationship with the world.\"",
			"image": ""
		},
		{
			"statement": "Narrate your day yesterday by using the Simple Past and the Past Continuous.",
			"image": ""
		},
		{
			"statement": "Narrate your last vacation by using the Simple Past and the Past Continuous.",
			"image": ""
		},
		{
			"statement": "Give your opinion on violence in your city in a subtle way.",
			"image": ""
		},
		{
			"statement": "Give your opinion on marriage and betrayal emphatically.",
			"image": ""
		},
		{
			"statement": "Give your opinion on abortion in a subtle way.",
			"image": ""
		},
		{
			"statement": "Give your opinion on the future of your country emphatically.",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"I’ll think about it.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"I’ll do my best.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"It won’t take long.\"",
			"image": ""
		},
		{
			"statement": "Say three activities you can do.",
			"image": ""
		},
		{
			"statement": "Say three activities you can’t do at work.",
			"image": ""
		},
		{
			"statement": "Make one request with can and one with could.",
			"image": ""
		},
		{
			"statement": "Use the reflexive pronoun yourself in a sentence.",
			"image": ""
		},
		{
			"statement": "Use the reflexive pronoun themselves in a sentence.",
			"image": ""
		},
		{
			"statement": "Say three places in a hotel.",
			"image": ""
		},
		{
			"statement": "Mention two sentences you could say at a restaurant.",
			"image": ""
		},
		{
			"statement": "Name three sections of a menu.",
			"image": ""
		},
		{
			"statement": "Make three predictions with the modal verb will about your professional life.",
			"image": ""
		},
		{
			"statement": "Make three predictions with a modal verb in the negative form about your family.",
			"image": ""
		},
		{
			"statement": "Make three predictions with the modal verb will about your country.",
			"image": ""
		},
		{
			"statement": "Create sentences with the words several and a bunch.",
			"image": ""
		},
		{
			"statement": "Create a narration with the time expressions \"two days ago\" and \"right now.\"",
			"image": ""
		},
		{
			"statement": "Create a narration with the time expressions \"last night\" and \"at this moment.\"",
			"image": ""
		},
		{
			"statement": "Create a narration with the time expressions \"today\" and \"tomorrow.\"",
			"image": ""
		},
		{
			"statement": "Create a narration with the time expressions \"tomorrow\" and \"at the end of the week.\"",
			"image": ""
		},
		{
			"statement": "Create one sentence with when and one with while.",
			"image": ""
		},
		{
			"statement": "Complete the sentences: \"When my mother…\" and \"While my father…\"",
			"image": ""
		}
	],
	"Intermediate 2": [
		{
			"statement": "Say two things you shouldn’t do in a formal dinner.",
			"image": ""
		},
		{
			"statement": "Say two things you must do to learn English.",
			"image": ""
		},
		{
			"statement": "Give two pieces of advice for someone who is looking for a job.",
			"image": ""
		},
		{
			"statement": "Give two pieces of advice for someone who doesn’t have a good relationship with the boss.",
			"image": ""
		},
		{
			"statement": "Give two pieces of advice for someone who wants to change professions.",
			"image": ""
		},
		{
			"statement": "Say three things you mustn’t do while driving.",
			"image": ""
		},
		{
			"statement": "Create three sentences comparing two cities with the comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Create two sentences comparing two professions with the comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Create two sentences comparing two places in your city with the comparative of equality.",
			"image": ""
		},
		{
			"statement": "Create four sentences comparing two celebrities with any comparative form.",
			"image": ""
		},
		{
			"statement": "Talk about the best restaurant in your city and justify your opinion with three sentences.",
			"image": ""
		},
		{
			"statement": "Talk about the worst trip you took and justify it with three sentences.",
			"image": ""
		},
		{
			"statement": "Give your opinion on your country with four examples of any comparative or superlative forms.",
			"image": ""
		},
		{
			"statement": "Talk about five of your plans using be going to.",
			"image": ""
		},
		{
			"statement": "Say three things that are going to happen to the world in the next five years.",
			"image": ""
		},
		{
			"statement": "Give your opinion on legalizing drugs (express doubt).",
			"image": ""
		},
		{
			"statement": "Give your opinion on death penalty (express certainty).",
			"image": ""
		},
		{
			"statement": "Give your opinion on bullying (use connectors of addition and conclusion).",
			"image": ""
		},
		{
			"statement": "Give your opinion on internet addiction (use connectors of contrast and conclusion).",
			"image": ""
		},
		{
			"statement": "Give your opinion on terrorism (use connectors of addition and contrast).",
			"image": ""
		},
		{
			"statement": "Give your opinion on same-sex marriage (use connectors of addition and conclusion).",
			"image": ""
		},
		{
			"statement": "Give your opinion on your profession (use connectors of addition and contrast).",
			"image": ""
		},
		{
			"statement": "Narrate a brief event of your life using past, present",
			"image": ""
		},
		{
			"statement": "Narrate your day since you woke up this morning and include what you are planning to do after class.",
			"image": ""
		},
		{
			"statement": "List the consequences of pollution in the world (use connectors of consequence and exemplification).",
			"image": ""
		},
		{
			"statement": "Say four things that anyone is or isn’t supposed to do to have a happy marriage.",
			"image": ""
		},
		{
			"statement": "Say four things that parents are or aren’t supposed to do to raise their children.",
			"image": ""
		},
		{
			"statement": "Say two things that you are able to do and two things that you are willing to do.",
			"image": ""
		},
		{
			"statement": "Say three things that anyone had better do to get a promotion.",
			"image": ""
		},
		{
			"statement": "Answer the question with four sentences: \"What would you do if you were a millionaire?\"",
			"image": ""
		},
		{
			"statement": "Answer the question with four sentences: \"What would you do if you moved to another country?\"",
			"image": ""
		},
		{
			"statement": "Make three requests or offers with the modal verb would.",
			"image": ""
		},
		{
			"statement": "Say two common sentences you would use or listen to while shopping and mention the context.",
			"image": ""
		},
		{
			"statement": "Say two common sentences you would use or listen to while traveling by plane and mention the context.",
			"image": ""
		},
		{
			"statement": "Complete the sentence \"Ron is going to New York next week. Actually",
			"image": "…\""
		},
		{
			"statement": "Complete the sentence \"My boss asked me to make a report on the last meeting. By the way",
			"image": "…\""
		}
	],
	"Intermediate 3": [
		{
			"statement": "Answer the question \"What have you done lately?\"",
			"image": ""
		},
		{
			"statement": "Answer the question Have you ever traveled abroad? (If you have give details. If not, explain why.)",
			"image": ""
		},
		{
			"statement": "Answer the question Have you ever gone camping? (If you have give details. If not, explain why.)",
			"image": ""
		},
		{
			"statement": "Complete the sentences: \"I have never…\" and \"I have already…\"",
			"image": ""
		},
		{
			"statement": "Complete the sentences: \"I haven’t….yet.\" and \"I have always…\"",
			"image": ""
		},
		{
			"statement": "Say three things you have been doing this week.",
			"image": ""
		},
		{
			"statement": "Say three things you haven’t been doing but you would like to do.",
			"image": ""
		},
		{
			"statement": "Say three things you have never done but you would love to do.",
			"image": ""
		},
		{
			"statement": "Say three things you haven’t done and you never will.",
			"image": ""
		},
		{
			"statement": "Give good and bad news by using the expressions studied.",
			"image": ""
		},
		{
			"statement": "Defend your opinion on religious intolerance by narrating a story.",
			"image": ""
		},
		{
			"statement": "Defend your opinion on gun control by analyzing pros and cons.",
			"image": ""
		},
		{
			"statement": "Defend your opinion on corruption by quoting someone and by referring to someone else’s opinion.",
			"image": ""
		},
		{
			"statement": "Give someone pieces of advice on their career by using three different strategies.",
			"image": ""
		},
		{
			"statement": "Make a formal complaint about a restaurant by listing three situations.",
			"image": ""
		},
		{
			"statement": "Make a complaint about a hotel by listing three situations.",
			"image": ""
		},
		{
			"statement": "Mention two expressions used to check understanding and two expressions used to ask for more details or explanations.",
			"image": ""
		},
		{
			"statement": "Explain something you know how to do (use ordinal numbers).",
			"image": ""
		},
		{
			"statement": "Explain something you do at work (use the expressions \"Don’t forget to…\" and \"Bear in mind that…\")",
			"image": ""
		},
		{
			"statement": "Explain how to make a good impression at work (use the expressions \"To start with…\" and \"Afterwards…\").",
			"image": ""
		},
		{
			"statement": "Say two requests you make at home to your family with \"Would you mind…?\"",
			"image": ""
		},
		{
			"statement": "Say two favors you ask your co-workers with \"Would you mind…?\"",
			"image": ""
		},
		{
			"statement": "List two illnesses and their symptoms.",
			"image": ""
		},
		{
			"statement": "What is the difference in meaning between these two sentences: \"I forgot to close the window\" and \"I forgot closing the window\"?",
			"image": ""
		},
		{
			"statement": "What is the difference in meaning between these two sentences: \"I like to dance\" and \"I like dancing\"?",
			"image": ""
		},
		{
			"statement": "Complete the sentences with the gerund or the infinitive form: \"I enjoy…\" and \"I plan…\"",
			"image": ""
		},
		{
			"statement": "Complete the sentences with the gerund or the infinitive form: \"I want…\" and \"I feel like…\"",
			"image": ""
		},
		{
			"statement": "Complete the sentences with the gerund or the infinitive form: \"I can’t help…\" and \"I choose…\"",
			"image": ""
		},
		{
			"statement": "Explain what \"profit\" and \"damage\" mean.",
			"image": ""
		},
		{
			"statement": "Explain what \"target public\" and \"sales forecast\" mean.",
			"image": ""
		},
		{
			"statement": "Give options by using either…or about a situation at work.",
			"image": ""
		},
		{
			"statement": "Think about your job and complete the sentence: \"You should neither…\"",
			"image": ""
		},
		{
			"statement": "Think about possible ways to seduce someone and create a sentence with either…or…",
			"image": ""
		},
		{
			"statement": "Think of people who made a difference in the world and create a sentence with both…and and one with not only…but also...",
			"image": ""
		},
		{
			"statement": "Think of travel destinations and create sentences with both…and and not only…but also…",
			"image": ""
		},
		{
			"statement": "Think of common tourist traps in your city and create a sentence with neither…nor…",
			"image": ""
		}
	],
	"Advanced 1": [
		{
			"statement": "Say things you had done before starting to study at Wise Up.",
			"image": ""
		},
		{
			"statement": "Say dreams you had had before becoming an adult.",
			"image": ""
		},
		{
			"statement": "Say places you had worked at before starting at your last job.",
			"image": ""
		},
		{
			"statement": "Say activities you will be doing at the end of the month.",
			"image": ""
		},
		{
			"statement": "Explain what \"to withdraw\" and \"to loan\" mean.",
			"image": ""
		},
		{
			"statement": "You just saw a serious car accident on the road. In your opinion, what must have happened?",
			"image": ""
		},
		{
			"statement": "Your best friend just got fired. What should your friend have done to avoid that?",
			"image": ""
		},
		{
			"statement": "Create two sentences to praise a co-worker on a project presentation.",
			"image": ""
		},
		{
			"statement": "Create two sentences to apologize for being late for a meeting—one formal and one informal.",
			"image": ""
		},
		{
			"statement": "Complete the sentence \"You had better arrive on time, otherwise…",
			"image": "\""
		},
		{
			"statement": "Complete the sentence \"I might be late for the meeting unless…\"",
			"image": ""
		},
		{
			"statement": "You have just been invited to a party: react by showing excitement or not.",
			"image": ""
		},
		{
			"statement": "Create a context in which you would use the sentence \"I couldn’t believe my eyes.\"",
			"image": ""
		},
		{
			"statement": "Create a context in which you would use the sentence \"I really don’t give a damn.\"",
			"image": ""
		},
		{
			"statement": "Create a context in which you would use the sentence \"He knocked it out of the park.\"",
			"image": ""
		},
		{
			"statement": "Create a context in which you would use the expression \"My bad!\"",
			"image": ""
		},
		{
			"statement": "List three things you believe you should have already done professionally by now.",
			"image": ""
		},
		{
			"statement": "List three things your best friend must have done this morning.",
			"image": ""
		},
		{
			"statement": "What’s the difference between these two sentences: \"I had never met Sarah\" and \"I have never met Sarah\"?",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"I had been working on it before you even asked me to.\"",
			"image": ""
		},
		{
			"statement": "Explain the difference between a tax and a fine.",
			"image": ""
		},
		{
			"statement": "Explain one procedure you do at work by using the modal verbs should and could.",
			"image": ""
		},
		{
			"statement": "Explain something you do at home (e.g. cooking) by using the modal verbs might and cannot.",
			"image": ""
		},
		{
			"statement": "Define \"happiness\" in two different ways.",
			"image": ""
		},
		{
			"statement": "Define \"success\" in two different ways.",
			"image": ""
		},
		{
			"statement": "Explain the meaning of \"to blackmail\" and \"to kidnap.\"",
			"image": ""
		},
		{
			"statement": "Explain the meaning of \"to press charges\" and \"to break into a house.\"",
			"image": ""
		},
		{
			"statement": "Complete the sentence \"John must have already arrived home hence…",
			"image": "\""
		},
		{
			"statement": "Create a context for the sentence \"Unfortunately the apartment was rented two days ago.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"Don’t worry the reports will be sent by noon.\"",
			"image": ""
		},
		{
			"statement": "What’s the difference in meaning between these sentences: \"The managers will finish the analysis on time\" and \"The analysis will be finished on time?\"",
			"image": ""
		},
		{
			"statement": "What is the difference in meaning between these sentences: \"Your car is being fixed\" and \"The best mechanic is fixing your car\"?",
			"image": ""
		},
		{
			"statement": "Choose a problem in your city and say what has been done to solve it.",
			"image": ""
		},
		{
			"statement": "Complete the sentences \"I had been planning…\" and \"I have been planning…\"",
			"image": ""
		},
		{
			"statement": "Solve the pronoun ambiguity in this fragment: \"Marvin and Barbie made some cookies. I love them so much…\"",
			"image": ""
		},
		{
			"statement": "Solve the pronoun ambiguity in this fragment: \"I just arrived in Tokyo on a private plane. It was beyond my expectation.\"",
			"image": ""
		}
	],
	"Advanced 2": [
		{
			"statement": "In your opinion what will have happened in the world by 2020?",
			"image": ""
		},
		{
			"statement": "What will you have done by the end of the year to improve your professional skills?",
			"image": ""
		},
		{
			"statement": "Explain the meaning of \"to root for\" and \"to put something forward.\"",
			"image": ""
		},
		{
			"statement": "Give your opinion on your country’s politicians (use one connector of addition, one of contrast, and one of conclusion).",
			"image": ""
		},
		{
			"statement": "Give your opinion on leading a healthy life (use one connector of addition, one of contrast, and one of conclusion).",
			"image": ""
		},
		{
			"statement": "Create two hypotheses on your professional life.",
			"image": ""
		},
		{
			"statement": "Create sentences that could come before and after this one: \"The prices of all products were raised.\"",
			"image": ""
		},
		{
			"statement": "Create sentences that could come before and after this one: \"The victim has been seen visiting the apartment several times.\"",
			"image": ""
		},
		{
			"statement": "Explain the meaning of \"to be the dark horse\" and \"to be the frontrunner.\"",
			"image": ""
		},
		{
			"statement": "Define \"family\" by saying what it is not.",
			"image": ""
		},
		{
			"statement": "Define \"friendship\" by making comparisons.",
			"image": ""
		},
		{
			"statement": "Define \"marriage\" by using metaphors.",
			"image": ""
		},
		{
			"statement": "Report the sentence \"Don’t call Mary Anne before 9 a.m.\"",
			"image": ""
		},
		{
			"statement": "Report the sentence \"What are you going to do next Sunday?\"",
			"image": ""
		},
		{
			"statement": "Report the sentence \"Call me if you need any assistance.\"",
			"image": ""
		},
		{
			"statement": "Report the sentence \"Can you do me a favor?\"",
			"image": ""
		},
		{
			"statement": "Report the sentence \"Does your sister have children?\"",
			"image": ""
		},
		{
			"statement": "Report the sentence \"The presentation won’t be ready for tomorrow.\"",
			"image": ""
		},
		{
			"statement": "Report the sentence \"I have never worked so much.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the proverb \"Two wrongs don’t make a right.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the proverb \"Don’t put all your eggs in one basket.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the proverb \"The early bird catches the worm.\"",
			"image": ""
		},
		{
			"statement": "If you could go back in time what profession would have chosen? Why?",
			"image": ""
		},
		{
			"statement": "Say something you regret doing.",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"I might have forgotten it at home.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"They might not have understood it.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"You could have done better.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"My parents wouldn’t have allowed me to do that.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"I would have done it differently.\"",
			"image": ""
		},
		{
			"statement": "Create a context for the sentence \"You may have made a huge mistake.\"",
			"image": ""
		},
		{
			"statement": "Complete the sentence \"I was at the meeting and to make a long story short\"",
			"image": ""
		},
		{
			"statement": "Complete the sentence \"Mark and Phil had a long conversation and to wrap it up…\"",
			"image": ""
		},
		{
			"statement": "Say two things you have been doing and two you should have already stopped doing.",
			"image": ""
		},
		{
			"statement": "Say two things you will be doing at the end of the month if you have some free time.",
			"image": ""
		},
		{
			"statement": "Say two things you would do if your day were six hours longer.",
			"image": ""
		},
		{
			"statement": "Say two things you will have done by the end of the year but that you shouldn’t do.",
			"image": ""
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/questions.json
// module id = 671
// module chunks = 0